export function getUrlParams(): URLSearchParams {
  return new URLSearchParams(window.location.search) || {};
}
type TUrlParams = Record<string, string | number | boolean>;

export function setUrlParams(
  params: TUrlParams,
  keepCurrentParams = true
): string {
  const searchParams = keepCurrentParams ? window.location.search : '';
  const urlParams = new URLSearchParams(searchParams);
  Object.entries(params).map(([key, value]) => urlParams.set(key, `${value}`));
  return urlParams.toString();
}
